<template>
    <section class="recipe">
        <div class="img-box container" v-lazy:background-image="img"
        :class="{
            'curry' : Contents.id == 0,
            'maho' : Contents.id == 1,
            'nabe' : Contents.id == 2}">
            <div class="title-wrap">
                <span class="caption" v-html="Contents.caption" data-aos="fade-right"/>
                <h2 class="title" v-html="Contents.name" data-aos="fade-right" data-aos-delay="400"/>
            </div>
            <div class="spice" data-aos="zoom-out-up" :class="{
            'curry' : Contents.id == 0,
            'maho' : Contents.id == 1,
            'nabe' : Contents.id == 2}">
                <Spice class="frame"/>
                <Dots class="dots" />
                <div class="circle">
                    <img src="@/assets/img/recipe/spice.jpg" alt="spice">
                </div>
            </div>
            <num1 class="num" v-if="Contents.id == 0" />
            <num2 class="num" v-if="Contents.id == 1" />
            <num3 class="num" v-if="Contents.id == 2" />
        </div>
        <div class="text-box" :class="{
            'curry' : Contents.id == 0,
            'maho' : Contents.id == 1,
            'nabe' : Contents.id == 2}">
            <div class="context" data-aos="fade-up">
                <p>{{ Contents.text }}</p>
                <div class="ingredients">
                    <span class="title" data-aos="fade-up">
                        ［材料  2人前］
                    </span>
                    <ul data-aos="fade-up" data-aos-delay="400">
                        <li v-for="item in material" :key="item" v-html="item" />
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Data from '@/assets/recipe.json'
import Spice from '@/assets/img/recipe/withspice.svg?inline'
import Dots from '@/assets/img/recipe/dots.svg?inline'
import img01 from '@/assets/img/recipe/curry_pc.jpg'
import img01Sp from '@/assets/img/recipe/curry_sp.jpg'
import img02 from '@/assets/img/recipe/maho_pc.jpg'
import img02Sp from '@/assets/img/recipe/maho_sp.jpg'
import img03 from '@/assets/img/recipe/nabe_pc.jpg'
import img03Sp from '@/assets/img/recipe/nabe_sp.jpg'
import num1 from '@/assets/img/num1.svg?inline'
import num2 from '@/assets/img/num2.svg?inline'
import num3 from '@/assets/img/num3.svg?inline'

import { vueWindowSize } from 'vue-window-size';
 
vueWindowSize.init();

export default {
    props:{
        Num: Number
    },
    components:{
        Spice,
        Dots,
        num1,num2,num3
    },
    data(){
        return{
            img: String
        }
    },
    computed:{
        Contents(){
            return Data.recipe[this.Num]
        },
        material(){
            return this.Contents.material
        }
    },
    created(){
        window.addEventListener('resize', this.resized);
    },
    methods:{
        resized(e){
            vueWindowSize.init();
            this.bgChange()
        },
        bgChange(){
            if(this.Num == 0){
                this.Selection(img01, img01Sp)
            }
            if(this.Num == 1){
                this.Selection(img02, img02Sp)
            }
            if(this.Num == 2){
                this.Selection(img03, img03Sp)
            }
        },
        Selection(pc, sp){
            if(this.windowWidth < 400){
                this.img = sp
            }
            if(this.windowWidth > 399){
                this.img = pc
            }
        }
    },
    mounted(){
        this.bgChange()
    }

}
</script>

<style lang="scss" scoped>

.recipe{
    background: transparent;
    position: relative;
    align-items: stretch;
    justify-content: space-between;
    flex-flow: row-reverse nowrap;
    @media #{$IE}{
        flex-flow: row nowrap;
    }
    min-height: 840px;
    overflow: hidden;
    @media #{$maxL}{
        flex-flow: column;
    }
    .img-box{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        min-height: 840px;
        flex-flow: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 0;
        background-repeat: no-repeat;
        background-position: left 20% bottom;
        background-size: cover;
        color: #fff;
        overflow: hidden;
        width: 60%;
        max-width: unset;
        &.curry{ background-color: $curry; }
        &.maho{ background-color: $maho;}
        &.nabe{ background-color: $nabe;}
        @extend %lazy;
        @media #{$minMax}{
            background-position: left 10% bottom;
        }
        @media #{$maxMax}{
            background-position: left 20% bottom;
        }
        @media #{$maxXL}{
            background-position: left 24% bottom;
        }
        @media #{$maxL}{
            width: 100%;
            position: relative;
            height: 100vh;
            background-position: left 20% bottom;
        }
        @media #{$maxS}{
            background-position: left 24% bottom;
        }
            .title-wrap{
                position: unset;
                margin-top: 76px;
                margin-left: 72px;
                @media #{$minMax}{
                    display: flex;
                    flex-flow: column;
                    align-items: flex-start;
                    justify-self: flex-start;
                    position: relative;
                    margin-left: 0;
                    font-size: 21px;
                    margin-top: 0;
                    top: 10%;
                    left: 45%;
                    .caption,.title{
                        position: relative;
                        top: 0;
                        left: 0;
                    }
                    .caption{
                        margin-bottom: 24px;
                        margin-left: 0.32em;
                    }
                }
                @media #{$maxM}{
                        margin-top: 56px;
                        margin-left: 20px;
                }
            }
            .caption{
                line-height: 1.56em;
                font-size: 1.72em;
                font-weight: 600;
                position: relative;
                font-family: $Default;
                @media #{$minMax}{
                    font-size: 1.24em;
                }
                @media #{$maxL}{
                    
                }
                @media #{$maxM}{
                    font-size: 1.65em;
                    position: absolute;
                    left: 20px;
                }
                @media #{$maxS}{
                    font-size: 5vw;
                }
            }
            .title{
                position: absolute;
                display: flex;
                flex-flow: column;
                font-size: 3.2em;
                //left: calc(50% - 2em);
                right: 10%;
                top: 20%;
                font-weight: 600;
                letter-spacing: 0.128em;
                @media #{$minMax}{
                    top: 20%;
                    right: 20%;
                    font-size: 2.75em;
                }
                @media #{$maxS}{
                    right: 20px;
                    top: 160px;
                    font-size: 2.64em;
                    min-width: 50%;
                }
                .blank{
                    position: relative;
                    color: red;
                }
            }
            .spice{
                width: 180px;
                height: 180px;
                position: absolute;
                bottom: 46%;
                right: 10%;
                @extend %flex;
                &.curry{
                        bottom: 40%;
                    }
                @media only screen and (min-width:1980px){
                    bottom: 40%;
                    right: unset;
                    left: 56%;
                    bottom: 43%;
                }
                @media #{$maxXL}{
                    right:40px;
                }
                @media #{$maxL}{
                    width: 20vw;
                    height: 20vw;
                    max-width: 140px;
                    max-height: 140px;
                    right: 20%;
                    bottom: 42%;
                    &.curry{
                        bottom: 38%;
                    }
                }
                @media #{$maxM}{
                    width: 36vw;
                    height: 36vw;
                    max-width: 120px;
                    max-height: 120px;
                    bottom: 46%;
                    right: 20%;
                    &.curry{
                        bottom: 42%;
                    }
                }
                @media screen and (max-width: 670px ){
                    right: 10%;
                }
                @media #{$maxS}{
                    right: 20px;
                    bottom: 50%;
                    &.curry{
                        bottom: 43%;
                        @media (min-height: 786px){
                            bottom: 42%;
                        }
                    }
                }
                svg{
                    z-index: 1;
                    fill: #fff;
                    #onFrame{
                        overflow: hidden;
                    }
                }
                .dots{
                    position: absolute;
                    width: 15%;
                    left: -20%;
                    transform: rotate(30deg);
                    top: 50%;
                    @media #{$maxM}{
                        transform: rotate(15deg);
                        left: -10%;
                        top: 80%;
                    }
                    @media #{$maxS}{
                        left: -10px;
                        top: calc(100% - 14px);
                        width: 20%;
                        transform: rotate(0deg);
                        @media (min-height: 800px){
                            
                        }
                    }
                }
                .frame{
                    position: relative;
                    height: 100%;
                    width: 100%;
                }
                .circle{
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 78%;
                    height: 78%;
                    padding: 0;
                    border-radius: 100%;
                    bottom: 2px;
                    z-index: 0;
                    overflow: hidden;
                    @extend %flex;
                        img{
                            object-fit: cover;
                            width: 105%;
                            height: 105%;
                            border-radius: 100%;
                            margin-bottom: 3px;
                            @media #{$maxL}{
                                
                            }
                        }
                }
            }
            .num{
                position: absolute;
                width: 15%;
                height: auto;
                bottom: 5%;
                left: 5%;
                @media #{$maxM}{
                    width: 20%;
                }
                @media #{$IE}{
                    max-height: 280px;
                }
            }
    }
    
    .text-box{
        position: relative;
        align-items: flex-end;
        &.curry{ background: $curry; }
        &.maho{ background: $maho;}
        &.nabe{ background: $nabe;}
        width: 30%;
        padding: 72px 5%;
        @media #{$maxL}{
            padding: 46px 40px;
            width: calc(100% - 80px);
        }
        @media #{maxM}{
            padding: 54px 40px;
            width: calc(100% - 80px);
        }
        @media #{$maxS}{
            padding: 24px 20px;
            width: calc(100% - 40px);
        }
        .context{
            @extend %flex;
            color: #fff;
            p{
                margin-bottom: 46px;
                line-height: 1.75em;
                font-size: 1.456em;
                @media #{$maxM}{
                    margin-bottom: 24px;
                }
            }
        }
        .ingredients{
            width: 100%;
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: flex-start;
            .title{
                padding: 1.2em 0;
                margin-bottom: 1.2em;
                border-bottom: 1px solid #fff;
                width: 100%;
                font-size: 1.186em;
                @media #{$maxM}{
                    font-size: 2.8vw;
                    padding: 1em 0;
                    margin-left: -0.5em;
                }
            }
            ul{
                width: 100%;
                padding: 0;
                margin: 0;
                display: flex;
                flex-flow: column;
                @media #{$maxM}{
                    flex-flow: row wrap;
                    justify-content: space-between;
                    align-items: flex-start;
                }
                li{
                    list-style: none;
                    margin-left: 0.5em;
                    margin-bottom: 0;
                    font-size: 1.186em;
                    line-height: 1.875em;
                    @media #{$maxM}{
                        width: calc(50% - 4px);
                        letter-spacing: -0.05em;
                        font-size: 2.84vw;
                        line-height: 2em;
                        text-align: left;
                        margin-left: 0;
                    }
                }
            }
        }
    }
}
</style>